import Marquee from "react-fast-marquee";

const PHRASES = [
  "Building Visionary Spaces",
  "Childcare Assets",
  "Gated Communities",
  "Bespoke Villas",
  "Commercial Hubs",
  "Custom Builds",
  "Elevating NSW Lifestyle",
];

export const EditorialMarquee = () => (
  <div className="py-14 border-y border-white/10 overflow-hidden" data-testid="editorial-marquee">
    <Marquee speed={32} gradient={false} pauseOnHover>
      {PHRASES.map((p, i) => (
        <span key={p} className="flex items-center shrink-0">
          <span
            className={`font-serif-lux italic text-3xl sm:text-5xl px-8 whitespace-nowrap ${
              i % 2 === 0 ? "text-white/85" : "text-transparent"
            }`}
            style={
              i % 2 !== 0
                ? { WebkitTextStroke: "1px rgba(255,255,255,0.35)" }
                : undefined
            }
          >
            {p}
          </span>
          <span
            className="inline-block w-2.5 h-2.5 rotate-45 shrink-0"
            style={{ background: "linear-gradient(135deg,#FF3D00,#FF1744)" }}
          />
        </span>
      ))}
    </Marquee>
  </div>
);
